import React from "react";
import {
  TableCell,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
  Chip,
  Box,
} from "@mui/material";
import { Layers } from "lucide-react";
import { alpha } from "@mui/material";

const StockCountAndPriceListRow = ({ row, onStockBatch }) => {
  const getStockStatus = (qty, reorderQty) => {
    if (qty === 0) return { label: "Out of Stock", color: "error" };
    else if (qty <= reorderQty) return { label: "Low Stock", color: "warning" };
    return { label: "In Stock", color: "success" };
  };

  const stockStatus = getStockStatus(row.qty, row.reOrderQty);

  return (
    <TableRow
      sx={{
        "&:hover": {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
        },
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell>
        <Typography variant="body2" fontWeight={500}>
          {row.relatedBranch?.name ?? "N/A"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" fontWeight={500}>
          {row.relatedItem?.code ?? "N/A"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" fontWeight={500}>
          {row.relatedItem?.medicineItemName ?? "N/A"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" fontWeight={500}>
          {row.relatedUnit?.name ?? "N/A"}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={500}>
          {row.purchasePrice?.toLocaleString()} MMK
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={500}>
          {row.sellingPrice?.toLocaleString()} MMK
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={600}>
          {row.qty}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" color="text.secondary">
          {row.reOrderQty}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Chip
          label={stockStatus.label}
          color={stockStatus.color}
          size="small"
          variant="outlined"
        />
      </TableCell>
      <TableCell align="center">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 0.5,
          }}
        >
          <Tooltip title="StockBatch">
            <IconButton size="small" onClick={() => onStockBatch(row)}>
              <Layers size={16} />
            </IconButton>
          </Tooltip>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default StockCountAndPriceListRow;
